import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import NavBar from "../../Nav Bar/NavBar";
import googlePlay from "../../assets/googleDark.svg";
import appStore from "../../assets/appleDark.svg";
import vipImage from "../../assets/Rectangle.png";
import VipPop from "../../assets/vipPop.png";
// import CheckMark from "../../assets/checkBox.svg";
import rateImage from "../../assets/notif_img.png";
// import RatePop from "../../assets/组 9965@1x 4.png";
// import CheckMark2 from "../../assets/checkMark2.svg";
import orderImage from "../../assets/rectangle3.png";
import OrderPop from "../../assets/组 9965@1x 2.png";
import PriceImage from "../../assets/Rectangle4.png";
import PricePop from "../../assets/组 9942@1x 1 (1).png";
import SignInImage from "../../assets/Rectangle5.png";
import SignInPop from "../../assets/组 9942@1x 2.png";
import wideRectangle from "../../assets/组 9974@1x 1.png";
import shareImage from "../../assets/Rectangle7.png";
import UsdtImage from "../../assets/Rectangle6.png";
import UsdtPop from "../../assets/组 9942@1x 3.png";
import Group from "../../assets/Group1.png";
import CouponsPop1 from "../../assets/蒙版组 1077@1x 2.png";
import CouponsPop2 from "../../assets/蒙版组 1079@1x 2.png";
import CouponsPop3 from "../../assets/蒙版组 1080@1x 2.png";
import vipPop1 from "../../assets/组 9962@1x 2.png";
import vipPop2 from "../../assets/组 9963@1x 2.png";
import vipPop3 from "../../assets/组 10096@1x 2.png";
import {
  Header,
  P,
  H3,
  StoreDiv,
  ImageDiv,
  VipPopImg,
  SecondSection,
  VipSubContainer,
  H4,
  VipText,
  ThirdSection,
  RatePopImg,
  RateH4,
  FourthSection,
  OrderH4,
  OrderSubContainer,
  OrderPopImg,
  FifthSection,
  CardOne,
  CardOneImage,
  CardTwo,
  CardTwoImage,
  PriceH5,
  SignInH5,
  SignInText,
  CardPop,
  WideText,
  SixthSection,
  CardThree,
  UsdH5,
  UsdImg,
  CardFour,
  CardFourH5,
  ShareImage,
  UsdtCardPop,
  GroupPop,
  CouponsImg1,
  CouponsImg2,
  CouponsImg3,
  VipPop1,
  VipPop2,
  VipPop3,
  RateImageDiv,
  OrderImageDiv,
  PriceImageDiv,
  VipImage,
  OrderText,
  RateImage,
  OrderImage,
  StoreLink,
  CardThreeText,
} from "./product.styles";
import "../../components/product features styling/productFeatures.css";
import Button from "../../components/button/Button";
import ColoredLogo from "../../assets/ColoredLogo.svg";

const ProductFeatures = () => {
  useEffect(() => {
    AOS.init({ duration: 1500, once: true });
  }, []);

  return (
    <div>
      <NavBar linkColor="#000000" logo={ColoredLogo} bg="#fff" />
      <section className="firstSection" data-aos="fade-up">
        <div>
          <Header>What Our App Offers</Header>
          <P>
            GiftCard8 is your go-to platform for selling gift cards with ease
            and confidence. Enjoy quick account setup, seamless gift card
            submissions, and instant payouts, all in one place. With top-notch
            security, a user-friendly interface, and 24/7 availability, we make
            trading gift cards simple, fast, and reliable. Turn your gift cards
            into cash!
          </P>
        </div>

        <div>
          <H3>Get the App</H3>

          <StoreDiv>
            <StoreLink href="https://play.google.com/store/apps/details?id=com.yihua.giftcard">
              <img src={googlePlay} alt="Google Store" />
            </StoreLink>
            <StoreLink href="https://apps.apple.com/ng/app/giftcard8-redeem-gift-cards/id6746798308" target="_blank">
              <img src={appStore} alt="Apple store" />
            </StoreLink>
          </StoreDiv>
        </div>
      </section>

      <div className="secondSectionContainer" data-aos="fade-up">
        <SecondSection>
          <ImageDiv>
            <VipImage src={vipImage} alt="" />
            <VipPopImg src={VipPop} alt="" />
          </ImageDiv>
          <div className="VipContainer">
            <H4>New VIP Level Benefits</H4>
            <VipSubContainer>
              <VipText>
                Enjoy up to 6% VIP cashback and other exclusive privileges.
              </VipText>
            </VipSubContainer>
          </div>
        </SecondSection>
      </div>

      <div className="thirdSectionContainer" data-aos="fade-up">
        <ThirdSection>
          <div className="rateSection">
            <div>
              <RateH4>
                Stay updated with
                <br />
                Exchange Rate Alerts
              </RateH4>
            </div>
            <p className="rateText">
              {" "}
              Never miss the best exchange rates again! Subscribe now to receive
              real-time notifications and make informed decisions in the market.
              Keep track and make the best decision.
            </p>
            <Button
              actionType="redirect"
              redirectUrl="http://giftcard8.com/account"
              className="button"
            >
              Sign Up
            </Button>
          </div>
          <RateImageDiv>
            <RateImage src={rateImage} alt="" />
            <RatePopImg src={OrderPop} alt="" />
          </RateImageDiv>
        </ThirdSection>
      </div>

      <div className="fourthSectionContainer" data-aos="fade-up">
        <FourthSection>
          <div className="OrderImagesContainer">
            <OrderImageDiv>
              <OrderImage src={orderImage} alt="" />
              <OrderPopImg src={OrderPop} alt="" />

              <VipPop1 src={vipPop1} alt="" />
              <VipPop2 src={vipPop2} alt="" />
              <VipPop3 src={vipPop3} alt="" />
            </OrderImageDiv>
          </div>
          <div className="orderSubContainer">
            <OrderH4>Order overtime compensation</OrderH4>
            <OrderSubContainer>
              <OrderText style={{ width: "330px" }}>
                Guarantee the timeliness of each transaction.
              </OrderText>
            </OrderSubContainer>
          </div>
        </FourthSection>
      </div>

      <div className="fifthSectionContainer" data-aos="fade-up">
        <FifthSection>
          <CardOne>
            <PriceH5>
              Trade with us and stand a chance to win an iPhone and cash prizes!
            </PriceH5>
            <PriceImageDiv>
              <CardOneImage src={PriceImage} alt="" />
              <CardPop src={PricePop} alt="" />

              <WideText src={wideRectangle} alt="" />
            </PriceImageDiv>
          </CardOne>
          <CardTwo>
            <SignInH5>Sign in to receive coupons</SignInH5>
            <SignInText style={{ color: "#fff" }}>
              Sign in daily to receive exclusive coupons.
            </SignInText>
            <PriceImageDiv>
              <CardTwoImage src={SignInImage} alt="" />
              <CardPop src={SignInPop} alt="" />

              <CouponsImg1 src={CouponsPop1} alt="" />
              <CouponsImg2 src={CouponsPop2} alt="" />
              <CouponsImg3 src={CouponsPop3} alt="" />
            </PriceImageDiv>
          </CardTwo>
        </FifthSection>
      </div>

      <div className="sixthSectionContainer" data-aos="fade-up">
        <SixthSection>
          <CardThree>
            <UsdH5>USDT wallet</UsdH5>
            <CardThreeText style={{ color: "#fff" }}>
              Managing your funds made simple with our USDT wallet.
            </CardThreeText>
            <div>
              <UsdImg src={UsdtImage} alt="" />
              <UsdtCardPop src={UsdtPop} alt="" />
            </div>
            <GroupPop src={Group} alt="" />
          </CardThree>
          <CardFour>
            <CardFourH5>
              Share with friends and get unlimited rewards. The more you share,
              the more rewards you get.
            </CardFourH5>
            <div>
              <ShareImage src={shareImage} alt="" />
            </div>
          </CardFour>
        </SixthSection>
      </div>
    </div>
  );
};

export default ProductFeatures;
